import { NamedEntityDto } from './named.dto';

export class SkinTypeDto extends NamedEntityDto {}
